import { render, staticRenderFns } from "./view_list_card.vue?vue&type=template&id=19360f92&scoped=true"
import script from "./view_list_card.vue?vue&type=script&lang=js"
export * from "./view_list_card.vue?vue&type=script&lang=js"
import style0 from "./view_list_card.vue?vue&type=style&index=0&id=19360f92&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19360f92",
  null
  
)

export default component.exports